<template>
    <div>
        <CRow
            class="ml-5 mr-5 mb-5"
            style="width: -webkit-fill-available; z-index: 1"
          >
            <Mainlayout></Mainlayout>
            </CRow>
        <CRow class="bg-white">
          <CCol sm="12">
            <div style="background: #fff" id="schedule" class="m-0">
              <CContainer class="mt-5 mb-5 text-center">
                <h2 class="text-black custom-font text-center mt-5">
                  OUR CLASS SCHEDULE
                </h2>
                <!-- <h4 class="text-center">
                  If you can't see the any classes, please click this button
                  <CButton
                    style="border-radius: 50px"
                    type="button"
                    color="success"
                    @click="ReloadButton"
                    >Reload</CButton
                  >
                </h4> -->

                <br /><br />
                <CAlert color="info">
                  <h5>
                    The available to join button is for all classes with group
                    students (students more than 2). You can click directly on
                    the class code in this table for more information or to
                    join/register for the class you need. The “other” button is
                    for classes already registered and running with one-to-one
                    or small-group students.
                    <!-- <CButton
                  style="border-radius: 50px"
                  type="button"
                  color="success"
                  @click="GotoWhatssap"
                  class="mt-1"
                  >Click Here</CButton
                > -->
                  </h5>
                </CAlert>
                <br />
                <CButton
                  style="border-radius: 50px"
                  type="button"
                  color="success"
                  @click="ScheduleClass()"
                  size="lg"
                  class="mr-2"
                  :style="
                    isShowPrimary
                      ? 'color: #fff;background: #007cef;font-family: Montserrat;font-style: normal;font-weight: 600;'
                      : 'background:darkgray;border: 1px solid white;color:#fff;font-family: Montserrat;font-style: normal;font-weight: 600;'
                  "
                  >Available Class to Join</CButton
                >

                <CButton
                  style="border-radius: 50px"
                  type="button"
                  color="success"
                  size="lg"
                  @click="AllSchedule()"
                  :style="
                    isShowSecondary
                      ? 'color: #fff;background: #007cef;font-family: Montserrat;font-style: normal;font-weight: 600;'
                      : 'background:darkgray;border: 1px solid white;color:#fff;font-family: Montserrat;font-style: normal;font-weight: 600;'
                  "
                  >Others</CButton
                >
                <div class="text-left">Filter Grade</div>

                <div v-if="scheduleclass === true">
                  <CSelect
                    :value.sync="selectedGrade"
                    :options="gradeOptions"
                    @change="FilteredGrade()"
                  />
                  <vue-cal
                    class="vuecal--white-theme"
                    :events="FilteredGrades"
                    :time-from="7 * 60"
                    events-count-on-year-view="events-count-on-year-view"
                    events-on-month-view="short"
                    active-view="month"
                  >
                    <template v-slot:no-event="">No event 👌</template>
                  </vue-cal>
                </div>
                <div v-if="others === true">
                  <CSelect
                    :value.sync="selectedGradeAll"
                    :options="gradeOptions"
                    @change="FilteredGradeAll()"
                  />
                  <vue-cal
                    class="vuecal--white-theme"
                    :events="FilteredGradesAll"
                    :time-from="7 * 60"
                    events-count-on-year-view="events-count-on-year-view"
                    events-on-month-view="short"
                    active-view="month"
                  >
                    <template v-slot:no-event="">No event 👌</template>
                  </vue-cal>
                </div>
              </CContainer>
            </div>
          </CCol>
        </CRow>
        <Footerlayout></Footerlayout>
    </div>
</template>



<script>
import Vue from "vue";
import VueMeta from "vue-meta";

Vue.use(VueMeta);
import { Carousel3d, Slide } from "vue-carousel-3d";
import AnimatedNumber from "animated-number-vue";
import backgroundUrl from "../assets/img/bg3.png";

// import Translator from "vue-gtranslate";
// import "vue-gtranslate/translator.css";

Vue.use(require("vue-moment"));
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";

import Mainlayout from "../containers/AllHeaderLanding.vue";
import Footerlayout from "../containers/TheFooter.vue";

import VueAgile from "vue-agile";
Vue.use(VueAgile);

// in component

import AOS from "aos";
import "aos/dist/aos.css";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);

import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

import _ from "lodash";
import $ from "jquery";

import MenuIcon from "vue-material-design-icons/Menu.vue";
new Vue({
  el: "#navbar",

  data() {
    return {
      view: {
        topOfPage: true,
      },
    };
  },
  beforeMount() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.pageYOffset > 400) {
        if (this.view.topOfPage) {
          this.view.topOfPage = false;
          el.setAttribute(
            "style",
            "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
          );
        }
      } else {
        if (!this.view.topOfPage) this.view.topOfPage = true;
        el.setAttribute(
          "style",
          "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
        );
      }
    },
  },
});
export default {

  name: "Login",
  components: {
    Carousel3d,
    Slide,
    VueCal,
    MenuIcon,
    agile: VueAgile,
    Mainlayout,
    AnimatedNumber,
    backgroundUrl,
    Footerlayout,
  },
  data() {
    return {
      slides: 5,
      selectedGrade: "SELECT GRADE",
      selectedGradeAll: "SELECT GRADE",
      gradeOptions: [],
      FilteredGrades: [],

      FilteredGradesAll: [],

      counter: "",
      round: "",

      scheduleclass: false,
      others: true,

      isShowPrimary: false,
      isShowSecondary: true,

      popupdetail: false,
      popupform: true,

      SubmitDataDone: false,
      SubmitData: true,

      Name: "",
      Email: "",
      Grade: "",
      Subject: "",
      Mobile: "",
      isSubmitting: false,

      SubmittedForm: false,
      Error: false,
    };
  },
  created() {
    AOS.init();
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    this.GetScheduleStudent();
    this.GetScheduleStudentAll();
    this.GetCounter();

  // if (window.location.hostname !== "www.pickiddo.com") {
  //    window.location.href = "https://www.pickiddo.com";
  // }  
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  computed: {
    values: {
      get: function () {
        var t = this.counter;
        console.log("test" + t);
        return t;
      },
    },
    valuesTotal: {
      get: function () {
        var t = 30876;
        console.log("test" + t);
        return t;
      },
    },
  },

  methods: {
    ReloadButton() {
      window.open("https://www.pickiddo.com", "_self");
    },
    async GetCounter() {
      this.$API
        .get(this.$CounterClass, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.counter = response.data;
          }
        });
    },
    GotoWhatssap() {
      location.replace(
        "https://wa.me/600106597700?text=+Hi, I would like to ask about One To One"
      );
    },
    formatToPrice(values) {
      return ` ${values.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
    },
    async GetCounter() {
      this.$API
        .get(this.$CounterClass, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.counter = response.data;
          }
        });
    },
    onScroll() {
      // Get the current scroll position
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 0) {
        return;
      }
      // Here we determine whether we need to show or hide the navbar
      this.showNavbar = currentScrollPosition < this.lastScrollPosition;
      // Set the current scroll position as the last scroll position
      this.lastScrollPosition = currentScrollPosition;
    },
    handleScroll() {
      if (window.pageYOffset > 1000) {
        if (this.view.topOfPage) {
          this.view.topOfPage = false;
        } else {
          this.view.topOfPage = true;
        }
      }
    },
    FilteredGrade() {
      console.log("masuk");
      this.FilteredGrades = this.schedule;
      var combinedrates = [];
      for (let i in this.FilteredGrades) {
        let item = this.FilteredGrades[i];

        combinedrates.push({
          Grade: item.Grade,
          start: item.start,
          end: item.end,
          title:
            '<a href="' +
            item.LinkJoin +
            '">' +
            item.title +
            "\n" +
            item.Time +
            "</a>",
          class: item.ThemeColor,
        });
      }

      this.FilteredGrades = combinedrates;

      this.FilteredGrades = _.filter(
        this.FilteredGrades,
        (item) => item.Grade === this.selectedGrade
      );
    },
    FilteredGradeAll() {
      console.log("masuk");
      this.FilteredGradesAll = this.schedules;
      var combinedrates = [];
      for (let i in this.FilteredGradesAll) {
        let item = this.FilteredGradesAll[i];

        combinedrates.push({
          Grade: item.Grade,
          start: item.start,
          end: item.end,
          title: "<div>" + item.title + "\n" + item.Time + "</div>",
          class: item.ThemeColor,
        });
      }

      this.FilteredGradesAll = combinedrates;

      this.FilteredGradesAll = _.filter(
        this.FilteredGradesAll,
        (item) => item.Grade === this.selectedGradeAll
      );
    },
    GetScheduleStudent() {
      this.$API
        .get(this.$ScheduleStudentAll, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.schedule = response.data;
            this.FilteredGrades = this.schedule;

            console.log("theme" + this.FilteredGrades.class);

            var scheduleNames = _.uniq(_.map(response.data, "Grade"));
            scheduleNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.gradeOptions = scheduleNames;
            this.gradeOptions.unshift("SELECT GRADE");

            var combinedrates = [];
            for (let i in this.FilteredGrades) {
              let item = this.FilteredGrades[i];

              combinedrates.push({
                Grade: item.Grade,
                start: item.start,
                end: item.end,
                title:
                  '<a href="' +
                  item.LinkJoin +
                  '">' +
                  item.title +
                  "\n" +
                  "<strong>" +
                  item.Time +
                  "</strong>" +
                  "</a>",
                class: item.ThemeColor,
              });
            }

            this.FilteredGrades = combinedrates;

            console.log("data:" + this.feedData);
          }
        });
    },
    GetScheduleStudentAll() {
      this.$API
        .get(this.$AllScheduleStudent, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.schedules = response.data;
            this.FilteredGradesAll = this.schedules;

            console.log("theme" + this.FilteredGradesAll.class);

            var scheduleNames = _.uniq(_.map(response.data, "Grade"));
            scheduleNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.gradeOptions = scheduleNames;
            this.gradeOptions.unshift("SELECT GRADE");

            var combinedrates = [];
            for (let i in this.FilteredGradesAll) {
              let item = this.FilteredGradesAll[i];

              combinedrates.push({
                Grade: item.Grade,
                start: item.start,
                end: item.end,
                title:
                  "<div>" +
                  item.title +
                  "\n" +
                  "<strong>" +
                  item.Time +
                  "</strong>" +
                  "</div>",
                class: item.ThemeColor,
              });
            }

            this.FilteredGradesAll = combinedrates;

            console.log("data:" + this.feedData);
          }
        });
    },
    ScheduleClass() {
      this.scheduleclass = true;
      this.others = false;

      this.isShowPrimary = true;
      this.isShowSecondary = false;
    },
    AllSchedule() {
      this.others = true;
      this.scheduleclass = false;

      this.isShowPrimary = false;
      this.isShowSecondary = true;
    },
    GoToLogin() {
      window.open("https://app.pickiddo.com/v3/#/LoginPickiddo");
    },
    ClosePopup() {
      this.popupdetail = false;
    },
    OpenPopup() {
      this.popupdetail = true;
    },
    SubmitForm() {
      if (
        this.Name === "" ||
        this.Email === "" ||
        this.Mobile === "" ||
        this.Grade === "" ||
        this.Subject === ""
      ) {
        this.Error = true;
        this.isSubmitting = false;
        this.SubmittedForm = false;
      } else {
        this.Error = false;
        this.isSubmitting = true;
        this.SubmittedForm = true;
        const formData = new FormData();

        formData.append("Name", this.Name);
        formData.append("Email", this.Email);
        formData.append("Mobile", this.Mobile);
        formData.append("Grade", this.Grade);
        formData.append("Subject", this.Subject);

        return this.$API
          .post(this.$InsertRegisterMatch, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (
              response.status == 200 &&
              response.data != null &&
              response.data > 0
            ) {
              this.successModal = true;
            } else {
              this.errorModal = true;
            }
          })
          .catch((error) => {
            if (error.response) {
              console.log(error.response.status);
              this.Error = true;
              this.Message = error;
              this.Message = "Error";
            }
          });
      }
    },
    GoToApp() {
      this;
    },
  },
};
</script>
    <style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");

.c-header {
  /* background: rgb(23, 77, 124);
  background: linear-gradient(92deg, #174d7c, #1b7682);
  border-bottom: 0.01px solid #1a6783;
  border-bottom: 1px solid #636f83; */

  background: transparent;
  border-bottom: 0;
  border-bottom: 0;
  /* color: #fff; */
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  font-family: "Montserrat", sans-serif;
}
body {
  font-family: "Montserrat", sans-serif;
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}

label {
  font-family: "Montserrat", sans-serif;
}

body nav.onScroll {
  box-shadow: 0 0 10px #aaa;
  background-color: rgb(255, 255, 255);
  font-family: "Montserrat";
  font-style: normal;
}
body nav.onScroll ul li {
  color: #10b761;
}
body nav ul {
  margin-left: 3em;
  width: 25%;
  display: flex;
  justify-content: space-between;
}
body nav ul li {
  cursor: pointer;
  font-weight: 600;
  list-style-type: none;
  color: white;
}
body {
  top: 0 !important;
  font-family: "Montserrat", sans-serif;
}
li {
  font-family: "Montserrat", sans-serif;
}
.centered {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.card-custom-web {
  left: 0px;
  margin-top: 0px;
  width: 100%;
  background: #f9f9f9;
  -webkit-box-shadow: 0px 4px 20px rgb(0 0 0 / 8%);
  box-shadow: 0px 4px 20px rgb(0 0 0 / 8%);
  border-radius: 50px 0px 0px 0px;
  color: #000;
}

input {
  border-bottom: 2px solid #007cef;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: -webkit-fill-available;
}

.custom-user-input {
  /* Body/1/Semibold */

  display: flex;
  justify-content: center;
  flex-flow: row nowrap;
}
</style>